import { useState, useCallback, useMemo } from "react";
import { appendUrlParams } from "utils/urlUtils";

export const useSessionModals = ({ history }) => {
  const [reconciliationModalProps, setReconciliationModalProps] = useState({
    open: false,
    participant: null,
  });
  const [showAddCustomerModal, setShowAddCustomerModal] = useState(false);
  const [customerAttendancePopupProps, setCustomerAttendancePopupProps] =
    useState({ show: false, customerData: null });
  const [showLearnMorePopup, setShowLearnMorePopup] = useState(false);
  const [selectedParticipantForModal, setSelectedParticipantForModal] =
    useState(null);

  const handleOpenReport = useCallback(
    (participant) => {
      const customerData = {
        customer_uuid:
          participant.exly_user_uuid || participant.id || participant.uuid,
        customer_name: participant.customer_name || participant.name || "",
        customer_email:
          participant.customer_email || participant.user_email || "",
        customer_phone_numer: participant.customer_phone || "",
      };
      history.push({
        search: appendUrlParams("", {
          customer_uuid: customerData.customer_uuid,
        }),
      });
      setCustomerAttendancePopupProps({ show: true, customerData });
    },
    [history]
  );

  const handleCloseCustomerAttendancePopup = useCallback(() => {
    history.goBack();
    setCustomerAttendancePopupProps({ show: false, customerData: null });
  }, [history]);

  const handleOpenReconcile = useCallback((participant) => {
    setReconciliationModalProps({ open: true, participant });
  }, []);

  const handleCloseReconcile = useCallback(() => {
    setReconciliationModalProps({ open: false, participant: null });
  }, []);

  const handleOpenCreateNewBooking = useCallback((participant) => {
    setSelectedParticipantForModal(participant);
    setShowAddCustomerModal(true);
  }, []);

  const handleCloseAddCustomerModal = useCallback(() => {
    setShowAddCustomerModal(false);
    setSelectedParticipantForModal(null);
  }, []);

  return useMemo(
    () => ({
      reconciliationModalProps,
      showAddCustomerModal,
      customerAttendancePopupProps,
      showLearnMorePopup,
      setShowLearnMorePopup,
      selectedParticipantForModal,
      handleOpenReport,
      handleCloseCustomerAttendancePopup,
      handleOpenReconcile,
      handleCloseReconcile,
      handleOpenCreateNewBooking,
      handleCloseAddCustomerModal,
    }),
    [
      reconciliationModalProps,
      showAddCustomerModal,
      customerAttendancePopupProps,
      showLearnMorePopup,
      setShowLearnMorePopup,
      selectedParticipantForModal,
      handleOpenReport,
      handleCloseCustomerAttendancePopup,
      handleOpenReconcile,
      handleCloseReconcile,
      handleOpenCreateNewBooking,
      handleCloseAddCustomerModal,
    ]
  );
};
